// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"deliveryInfo-module--wrapper--3QyGQ","col":"deliveryInfo-module--col--2Zgy0"};